import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {interval, Subscription} from "rxjs";
import {
  EmbeddedFieldAutoUpdateFunction,
  EmbeddedFieldCallbackFunction,
  EmbeddedFieldModel
} from "../../models/embedded-field/embedded-field.model";

@Component({
  selector: 'sb-elapsed-time',
  templateUrl: './elapsed-time.component.html',
  styleUrls: ['./elapsed-time.component.scss']
})
export class ElapsedTimeComponent implements EmbeddedFieldModel, OnInit, OnDestroy {

  display: string;

  timer: Subscription;

  @Input()
  rendererProperties: any = {};

  @Input()
  initAngularComponent: EmbeddedFieldCallbackFunction;

  @Input()
  updateAngularComponent: EmbeddedFieldCallbackFunction;

  @Input()
  autoUpdateAngularComponent: EmbeddedFieldAutoUpdateFunction;

  constructor() { }

  ngOnInit(): void {
    this.timer = interval(1000).subscribe((value) => {
      this.display = value + "s";
    });
  }

  ngOnDestroy(): void {
    this.timer && this.timer.unsubscribe();
  }
}
